// import { getUserLogo } from 'api/authApiCall';
import React from 'react';


const InvoiceReceipt = ({ invoice, logoUrl }) => {
    // const logoUrl = getUserLogo();

    const subtotal = invoice.subtotal || 0;

    return (
        <div id="section-to-print" className="invoice-container">
            <div className="invoice-header">
                {/* <h1 className="company-name">{invoice.companyId?.name}</h1> */}
                {/* <img src={require("assets/img/brand/cello.jpg")} alt="User Logo" style={{ maxWidth: '200px', maxHeight: '100px' }} /> */}
                <div>
                    {logoUrl ? (
                        <img src={logoUrl} alt="User Logo" style={{ maxWidth: '200px', maxHeight: '100px' }} />
                    ) : (
                        <img src={require("assets/img/brand/aloapp.png")} style={{ maxWidth: '200px', maxHeight: '100px' }} />
                    )}
                </div>
                <div className="invoice-info">
                    <p>Invoice # : {invoice.invoiceId}</p>
                    <p>Created Date : {new Date(invoice.invoice_date).toLocaleDateString()}</p>
                </div>
            </div>

            <div className="address-container">
                <div className="customer-address">
                    <p>Name : {invoice.customer_name}</p>
                    <p>Address : {invoice.customer_address}</p>
                </div>
            </div>

            <table className="invoice-items">
                <thead>
                    <tr>
                        <th>DESCRIPTION</th>
                        <th>QUANTITY</th>
                        <th>PRICE</th>
                        <th>AMOUNT</th>
                    </tr>
                </thead>
                <tbody>
                    {invoice.products.map((product, index) => (
                        <tr key={index}>
                            <td>{product.product_name}</td>
                            <td>{product.quantity}</td>
                            <td>&#8373; {product.price}</td>
                            <td>&#8373; {product.price * product.quantity}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="invoice-summary">

                <div className="summary-item">
                    <span>Discount</span>
                    <span>&#8373; {invoice.discount || '0'}</span>
                </div>
                <div className="summary-item">
                    <span>Subtotal</span>
                    <span>&#8373;{Number(subtotal).toFixed(2).replace(/\.00$/, '')}</span>
                </div>
                <div className="summary-item total">
                    <span>Total</span>
                    <span>&#8373;{Number(subtotal).toFixed(2).replace(/\.00$/, '')}</span>
                </div>
            </div>

            <p className="thank-you">Thank you for your business!</p>

            <footer style={{ marginTop: "200px" }}>
                <small style={{ fontSize: "10px" }}>Created by Pascal with ❤️ </small>
            </footer>
        </div>
    );
};


export default InvoiceReceipt;
